import { Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Home from './Pages/Home';
import MoreAbout from './Pages/MoreAbout/MoreAbout';
import { handleRightClick } from './Utils/AppUtility';
import './index.css';
function App() {
  document.addEventListener('contextmenu', handleRightClick);
  document.addEventListener('keydown', function (event) {
    if (event.ctrlKey) {
      event.preventDefault();
    }
  });

  return (
    <div className="min-w-full overflow-hidden flex flex-col bg-gradient-to-tr from-slate-900 to-slate-900 border border-teal-400">
      <Navbar>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<MoreAbout />} />
        </Routes>
      </Navbar>
    </div>
  );
}

export default App;
